import { cn } from "@/lib/utils";

type Tone = "neutral" | "brand" | "success" | "danger" | "muted";

const tones: Record<Tone, string> = {
  neutral: "bg-foreground/5 text-foreground/80 ring-foreground/10",
  brand: "bg-brand/10 text-brand ring-brand/20",
  success: "bg-success-soft text-success ring-success/20",
  danger: "bg-danger-soft text-danger ring-danger/20",
  muted: "bg-surface-muted text-muted-foreground ring-foreground/10",
};

const statusMap: Record<string, Tone> = {
  new: "brand", pending: "brand", booked: "success", archived: "muted",
  scheduled: "neutral", active: "success", wrapped: "muted", post: "brand",
  draft: "muted", sent: "neutral", paid: "success", overdue: "danger",
  uploading: "muted", proofing: "brand", selected: "neutral", delivered: "success",
  signed: "success", expired: "danger",
  cull: "muted", edit: "neutral", retouch: "brand", review: "brand", done: "success",
  available: "success", "on-shoot": "brand", service: "muted", missing: "danger",
};

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  const tone = statusMap[status] ?? "neutral";
  return (
    <span className={cn(
      "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider ring-1 ring-inset",
      tones[tone],
      className,
    )}>
      {status}
    </span>
  );
}
